import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const Preloader = ({ onComplete }) => {
  const [phase, setPhase] = useState('logo');

  useEffect(() => {
    const timer1 = setTimeout(() => setPhase('text'), 600);
    const timer2 = setTimeout(() => setPhase('exit'), 1800);
    const timer3 = setTimeout(() => onComplete(), 2400);
    return () => { clearTimeout(timer1); clearTimeout(timer2); clearTimeout(timer3); };
  }, [onComplete]);

  return (
    <AnimatePresence>
      {phase !== 'exit' ? null : null}
      <motion.div
        className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#0B3A82]"
        initial={{ opacity: 1 }}
        animate={{ opacity: phase === 'exit' ? 0 : 1 }}
        transition={{ duration: 0.6, ease: 'easeInOut' }}
        style={{ pointerEvents: phase === 'exit' ? 'none' : 'all' }}
      >
        <div className="flex flex-col items-center">
          <motion.div
            initial={{ scale: 0.7, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          >
            <img
              src="/logo-white.png"
              alt="Asküçükler"
              className="h-16 sm:h-20 lg:h-24 w-auto"
            />
          </motion.div>

          <motion.div
            className="mt-8 flex items-center gap-1.5"
            initial={{ opacity: 0 }}
            animate={{ opacity: phase === 'text' || phase === 'exit' ? 1 : 0 }}
            transition={{ duration: 0.4 }}
          >
            {[0, 1, 2].map((i) => (
              <motion.div
                key={i}
                className="w-1.5 h-1.5 bg-[#FF6B2C] rounded-full"
                animate={{ scale: [1, 1.4, 1], opacity: [0.4, 1, 0.4] }}
                transition={{
                  duration: 0.8,
                  repeat: Infinity,
                  delay: i * 0.15,
                  ease: 'easeInOut',
                }}
              />
            ))}
          </motion.div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default Preloader;
